"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.load = exports.save = void 0;
var imports_1 = require("@lib/imports");
var diveCrew_hero_data_1 = require("@voyage/crew/diveCrew_hero_data");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var voyageMessageCrewCreate_1 = require("@voyage/multi/voyageMessageCrewCreate");
var voyageMessageCrewCreate_sidecar_1 = require("@voyage/multi/voyageMessageCrewCreate-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var namespace = 'voyage-saver-crew';
var save = function () {
    var d = {
        items: [],
    };
    imports_1.l.forEach(diveCrew_sidecar_1.diveCrew.getAll(), function (c) {
        if (c.type === diveCrew_1.EVoyageCrewType.Hero || c.type === diveCrew_1.EVoyageCrewType.Pet) {
            var body = null;
            if (c.type === diveCrew_1.EVoyageCrewType.Hero && c.heroState) {
                // let b = c.crewState.body
                // if (b) {
                //   body = {
                //     body: b.body.idx,
                //     bodyColor: b.bodyColor,
                //     hair: b.hair.idx,
                //     hairColor: b.hairColor,
                //     head: b.head.idx,
                //     headColor: b.headColor,
                //   }
                // }
            }
            d.items.push({
                type: c.type,
                loadedId: c.id,
                team: c.team,
                i: c.i,
                j: c.j,
                hitpoints: c.hitpoints,
                energy: c.energy,
                name: c.name,
                title: c.title,
                body: body,
            });
        }
    });
    return d;
};
exports.save = save;
var load = function (d) {
    try {
        imports_1.l.forEach(d.items, function (c) {
            voyageMessageCrewCreate_sidecar_1.voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
                crewId: c.loadedId,
                i: c.i,
                j: c.j,
                team: c.team,
                type: c.type,
                heroType: diveCrew_hero_data_1.EDiveHeroSubtype.None,
                enemyType: '',
                method: voyageMessageCrewCreate_1.EVoyageCrewCreateMethod.Normal,
                name: c.name,
                title: c.title,
                energy: c.energy,
                hitpoints: c.hitpoints,
            });
            // if (c.body) {
            //   let b = c.body
            //   voyageMessageCrewStyle.sendMessageAndImmediatelyExecute({
            //     crewId: c.loadedId,
            //     body: b.body,
            //     hair: b.hair,
            //     head: b.head,
            //     bodyColor: b.bodyColor,
            //     hairColor: b.hairColor,
            //     headColor: b.headColor,
            //   })
            // }
        });
    }
    catch (err) {
        console.log(namespace, 'load failed', err);
    }
};
exports.load = load;
